import './index.scss';

import imgcredito1 from '../../../../../assets/images/para-sua-empresa/img-credito/img-credito01@2x.png';

export const ACC = () => {

    return (
        <div className='container-select-credit'>
            <div className='cont-dados-1'>
                <h1> ACC - Adiantamento sobre contrato de Câmbio </h1>

                <p>
                    Um adiantamento sobre contrato de câmbio é um mecanismo financeiro que
                    permite a uma empresa receber antecipadamente o valor de uma exportação
                    futura.
                </p>

                <p>
                    Em essência, a empresa "vende" a futura receita de exportação para
                    uma instituição financeira (geralmente um banco) com um desconto.
                </p>

                <p>
                    Isso proporciona à empresa um fluxo de caixa imediato, enquanto o banco
                    assume o risco cambial e recebe o pagamento total quando a exportação
                    efetivamente ocorre.
                </p>

                <p>
                    Existem alguns pontos importantes a considerar sobre
                    adiantamento sobre contrato de câmbio:
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Taxas e Descontos:</span> O banco cobra taxas e descontos pelo serviço, que variam
                    de acordo com o prazo, o valor da operação, a moeda envolvida e o risco do
                    exportador.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Garantias:</span> Geralmente, são exigidas garantias para a operação,
                    como hipotecas, penhor ou fiança.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Risco Cambial:</span> Embora o exportador se proteja do risco cambial com o
                    adiantamento, ele abre mão de uma potencial valorização da moeda
                    estrangeira. Se a moeda estrangeira se valorizar em relação à moeda nacional
                    após o adiantamento, o exportador não se beneficiará dessa valorização.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Documentação:</span> A operação exige uma série de documentos, incluindo o
                    contrato de câmbio, a fatura proforma e outros documentos que comprovem a
                    exportação.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Regulamentação:</span> As operações de adiantamento sobre contrato de câmbio
                    são regulamentadas pelo Banco Central.
                </p>

            </div>
            <div className='cont-dados-2'>
                <img alt={imgcredito1} src={imgcredito1} />
                <div>
                    <h1> Vantagens do ACC </h1>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Fluxo de Caixa Imediato:</span> Permite que a empresa
                        receba recursos antecipadamente, o que pode ser
                        crucial para financiar a produção ou outras despesas.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Proteção contra Risco Cambial:</span> Elimina a incerteza
                        sobre o valor a ser recebido na data futura da
                        exportação.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Planejamento Financeiro:</span> Facilita o planejamento
                        financeiro da empresa, permitindo prever receitas e
                        despesas com maior precisão.
                    </p>

                    <div className='buttons-style inv' >
                        <a href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>
                    </div>
                </div>
            </div>
        </div>

    )
}

